export const SIDEBAR_WIDTH = 256;
